// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../subSeconds/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var subSeconds = convertToFP(fn, 2);
export default subSeconds;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/subSeconds/index.js
// module id = 1009
// module chunks = 0